
import { getCookie } from "utils/getCookie";
import { getParamByUrl } from "components";
import { Decrypt } from "utils/secret";
import { parse } from "utils/getParams"

// 生成年度关键词
// 取出percent不为0%的数据，按照percent从大到小排序，取出前3个，如果不足3个，则补齐3个
// 如果超出5个，则取前5个
// 如果currency不为--，则加入到数组中，加入到末尾
export function generateYearKeywords(array, currency, min = 2, max = 3) {
  const maxMum = ['zh', 'tw'].includes(window.g_lang) ? max : 2
  const t = window.t;
  const sortArr = array.sort((a, b) => {
    return Number(b.percent.replace('%', '')) - Number(a.percent.replace('%', ''))
  })
  const sortArr2 = sortArr.filter(item => item.percent !== '0%')
  const sortArr3 = sortArr.filter(item => item.percent === '0%')
  const copyArr = [...sortArr2]
  // 如果不为0%的数据小于min个，则补齐min个
  if (copyArr.length < min) {
    const diff = min - copyArr.length
    for (let i = 0; i < diff; i++) {
      copyArr.push(sortArr3[i])
    }
  } else if (copyArr.length > maxMum) {
    // 如果不为0%的数据大于 maxMum 个，则取前 maxMum 个
    copyArr.splice(maxMum)
  }

  const titles = copyArr.map(item => item.title)
  if (currency && currency !== '--') {
    titles.push(t('enthusiast', {
      currency,
    }))
  }
  return titles
}
// 对yearPersonilityDatas的数据进行排序，排序规则如下：
// 1. 如果所有数据的percent都为0%，则直接输出{ id: 16, title: 'sagacious.adventurer' }
// 2. 如果有数据的percent不为0%，则按照percent从大到小排序，取出第一个percent不为0%的数据，输出 此元素
// 3. 如果percent最大的数据中checkVip为true, 则直接输出此元素
export function sortYearPersonilityDatas(datas, defaultDatas) {
  // 首先需要过滤掉visible为false的数据
  const filteredDatas = datas.filter(item => item.visible ?? true)
  const filteredDefaultDatas = defaultDatas.filter(item => item.visible ?? true)
  // 根据 filterCheck 来过滤数组
  const firstCheckedDatas = filteredDatas.filter(item => item.filterCheck ?? false);
  const firstCheckedDefaultData = filteredDefaultDatas.filter(item => item.filterCheck ?? false)[0];

  const sortArr = firstCheckedDatas.sort((a, b) => {
    return Number(b.percent.replace('%', '')) - Number(a.percent.replace('%', ''))
  })
  const sortArr2 = sortArr.filter(item => item.percent !== '0%' && item.percent !== 'NAN%')
  if (sortArr2.length === 0) {
    return firstCheckedDefaultData
  }
  return sortArr2[0]
}

// 根据id来生成对应的背景色style
export function renderKeywordBackground(id) {
  const linearBackground = {
    1: 'linear-gradient(180deg, #4CA9FF 3.47%, #033FB4 75.71%, #2C6FF0 84%, #0810D2 99.93%)',
    2: 'linear-gradient(180deg, #6FD478 3.47%, #0E9261 75.71%, #42CE9D 84%, #1FC795 99.93%)',
    3: 'linear-gradient(180deg, #71E6EE 3.47%, #2171BA 75.71%, #4D9FEB 84%, #1A8ED0 99.93%)',
    4: 'linear-gradient(180deg, #FFAD4C 3.47%, #B46D03 75.71%, #F0AD2C 84%, #D2A508 99.93%)',
    5: 'linear-gradient(180deg, #F8D0FF 3.47%, #A13EBA 75.71%, #DD56D8 84%, #CE67F2 99.93%)',
    6: 'linear-gradient(180deg, #7262D3 3.47%, #4E11B0 75.71%, #7040D7 84%, #603BC9 99.93%)',
    7: 'linear-gradient(180deg, #CFCFCF 3.47%, #767575 75.71%, #979595 84%, #545454 99.93%)',
    8: 'linear-gradient(180deg, #F8D0FF 3.47%, #A13EBA 75.71%, #DD56D8 84%, #CE67F2 99.93%)',
    9: 'linear-gradient(180deg, #5586E5 3.47%, #2139BA 75.71%, #3B77EB 84%, #2B6CEB 99.93%)',
    10: 'linear-gradient(180deg, #FFAD4C 3.47%, #B46D03 75.71%, #F0AD2C 84%, #D2A508 99.93%)',
    11: 'linear-gradient(180deg, #5586E5 3.47%, #2139BA 75.71%, #3B77EB 84%, #2B6CEB 99.93%)',
    12: 'linear-gradient(180deg, #FF5F5F 3.47%, #B51A52 75.71%, #DD5676 84%, #F26778 99.93%)',
    13: 'linear-gradient(180deg, #FF5F5F 3.47%, #B51A52 75.71%, #DD5676 84%, #F26778 99.93%)',
    14: 'linear-gradient(180deg, #71E6EE 3.47%, #2171BA 75.71%, #4D9FEB 84%, #1A8ED0 99.93%)',
    15: 'linear-gradient(180deg, #FFAD4C 3.47%, #B46D03 75.71%, #F0AD2C 84%, #D2A508 99.93%)',
    16: 'linear-gradient(180deg, #FBB 3.47%, #DD5676 73.8%, #FF7BAB 91.89%, #F26778 99.93%)',
    17: 'linear-gradient(180deg, #6FD478 3.47%, #0E9261 75.71%, #42CE9D 84%, #1FC795 99.93%)',
    18: 'linear-gradient(180deg, #6FD478 3.47%, #0E9261 75.71%, #42CE9D 84%, #1FC795 99.93%)',
    19: 'linear-gradient(180deg, #6FD478 3.47%, #0E9261 75.71%, #42CE9D 84%, #1FC795 99.93%)',
    20: 'linear-gradient(180deg, #7262D3 3.47%, #4E11B0 75.71%, #7040D7 84%, #603BC9 99.93%)',
  };
  return linearBackground[id];
}

export function isValidField(field) {
  if (field === "" || field === "0" || field === null || field === undefined || field === '--') {
    return false;
  }
  return Number(field) > 0;
}

export function isZero(field) {
  if (field === "" || field === null || field === undefined || field === '--') {
    return true;
  }
  return Number(field) === 0;
}

export function getGenderParams() {
  let genderFromUrl = parse(Decrypt(getParamByUrl("p")))?.userGender;
  let gender = 0;

  if (genderFromUrl !== undefined && genderFromUrl !== null && genderFromUrl !== '') {
    gender = Number(genderFromUrl);
  } else {
    gender = getCookie('gender') || 0;
  }
  return gender;
}

// 将 data URL 转换为 Blob 对象的辅助函数
export function dataURLtoBlob(dataURL) {
  let arr = dataURL.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new Blob([u8arr], { type: mime });
}

// 隐藏关键信息
export const hiddenSensitiveMsg = (type) => {
  let list = document.querySelectorAll(".hiddenHtml");
  list.forEach((ele) => {
    ele.setAttribute("value", ele.innerText);
    if (!type) {
      if (ele.innerText.indexOf("USDT") >= 0) {
        ele.innerText = " **** USDT";
      } else if (ele.innerText.indexOf("%") >= 0) {
        ele.innerText = " **** %";
      } else {
        ele.innerText = " **** ";
      }
    }
  });
};

/**
 * 单位转换 科学数字
 * @param {*} num
 * @param {*} enforce_en 强制英文
 */
export const conversionUnit = (num) => {
  const isZh = window.g_lang === 'zh' || window.g_lang === 'tw';
  if (!num || typeof num === 'undefined' || isNaN(Number(num))) return ''
  const currentNum = Number(num)

  let result = ''
  if (isZh) {
    if (currentNum > 100000000) {
      result = Math.trunc((currentNum / 100000000) * 100) / 100 + '亿'
    } else if (currentNum > 10000) {
      result = Math.trunc((currentNum / 10000) * 100) / 100 + '万'
    } else if (currentNum < -100000000) {
      result = Math.trunc((currentNum / 100000000) * 100) / 100 + '亿'
    } else if (currentNum < -10000) {
      result = Math.trunc((currentNum / 10000) * 100) / 100 + '万'
    } else {
      result = (Math.trunc(currentNum * 10000) / 10000).toString()
    }
  } else {
    if (currentNum > 1000000000) {
      result = Math.trunc((currentNum / 1000000000) * 100) / 100 + 'B'
    } else if (currentNum > 1000000) {
      result = Math.trunc((currentNum / 1000000) * 100) / 100 + 'M'
    } else if (currentNum > 1000) {
      result = Math.trunc((currentNum / 1000) * 100) / 100 + 'K'
    } else if (currentNum < -1000000000) {
      result = Math.trunc((currentNum / 1000000000) * 100) / 100 + 'B'
    } else if (currentNum < -1000000) {
      result = Math.trunc((currentNum / 1000000) * 100) / 100 + 'M'
    } else if (currentNum < -1000) {
      result = Math.trunc((currentNum / 1000) * 100) / 100 + 'K'
    } else {
      result = (Math.trunc(currentNum * 10000) / 10000).toString()
    }
  }
  return result
}